<template>
  <div class="mainpage cardviewform" >
    <main v-if="showScratch && (post_detail && campaign_theme && scratchActive & post_detail.scratchType === 'normal')" class="" :style="main_style">
      <div ref="result"></div>
      <section id="introduction" class="al-flex"  >
        <div class="logo">
          <img :src="getdataImg(post_detail.logo_id)" />
        </div>
        <div class="campaign-text">
          <h2 :style="slogan_style">{{ post_detail.title }}</h2>
          <p><span class="popout" :style="award_style" >{{ post_detail.offer }}</span></p>
        </div>
        <div class="campaign-img" v-if="post_detail.campaign_image_id !== ''">
          <img style="border-radius: 10px" :src="getdataImg(post_detail.campaign_image_id)"  />
        </div>
      </section>
      <section v-if="!showPrize" class="form-area">
        <form data-vv-scope="interaction">
          <div v-for="(field, index) in post_detail.fieldList" :key="index">
            <label :style="label_style">{{ `${field.substring(0, 1).toUpperCase()}${field.substring(1).toLowerCase()}` }}</label>
            <input type="text" placeholder="Name" v-if="field === 'name'"
                   v-validate="'required'" v-model="name" :ref="field" :name="field">
            <input type="email" placeholder="Email" v-if="field === 'email'" :ref="field" :name="field"
                   v-validate="'required'" v-model="email">
            <input type="date" placeholder="Birthday" v-if="field === 'birthday'" :ref="field" :name="field"
                   v-validate="'required'" v-model="birthday">
            <input type="text" placeholder="Your Website" v-if="field === 'website'"
                   v-validate="'required'" v-model="website" :ref="field" :name="field">
            <phone-mask-input
              v-model="phone"
              autoDetectCountry
              v-if="field === 'phone'" :ref="`${field}`"
              showFlag
              @onValidate="onValidate"
              wrapperClass="relative"
              inputClass="cart-input"
              flagClass="phone-flag"
            />

            <div v-if="field === 'address'">
              <places-form v-if="!address" :ref="`${field}`" :location="address_text" :found="placesFound" class="w-full"></places-form>
              <div v-else class="al-input h-auto flex cursor-pointer" >
                <div class="flex-grow-1 flex flex-row w-full">
                  <div class="flex-grow-0 flex-wrap mr-4">
                    <input class="address-house" ref="houseNo" name="houseNo" v-validate="'required'" type="text" v-model="houseNo" placeholder="House No" />
                    <span v-show="errors.has('houseNo')" class="text-danger">{{ errors.first('houseNo') }}</span>
                  </div>
                  <div class="flex-grow-1 flex-wrap w-full">
                    {{address ? address_text : ''}}
                  </div>
                </div>
                <div class="flex-grow-0 py-2" @click="resetAddress"><i class="fa fa-refresh"></i></div>
              </div>
            </div>

            <span v-show="errors.has(field)" class="text-danger">{{ errors.first(field) }}</span>
          </div>
          <div v-for="(field, index) in custom_list" :key="`field${index}`" v-if="field.value">
            <label :style="label_style">{{ field.name }}</label>
            <phone-mask-input
              v-model="field.model"
              autoDetectCountry
              v-if="field.code === 'phone'" :ref="`${field.code}`"
              showFlag
              @onValidate="onValidate"
              wrapperClass="relative"
              inputClass="cart-input"
              flagClass="phone-flag"
            />

            <textarea
              v-else-if="field.code === 'longtext'"
              class="al-input textarea"
              v-model="field.model" :placeholder="field.name"
              v-validate="'required'" :ref="field.name" :name="field.name" />

            <input
              v-else
              v-model="field.model"
              :type="field.type" :placeholder="field.name"
              v-validate="'required'" :ref="field.name" :name="field.name">

            <span v-show="errors.has(field.name)" class="text-danger">{{ errors.first(field.name) }}</span>
          </div>
          <div class="form-agreement">
            <p :style="campaign_theme ? privacy_primary : ''" style="">Your contact information will only be used to keep you informed of upcoming exciting promotions and special events. We will never sell or distribute your information.</p>
            <div class="form-agreement-check" style="display: -webkit-box !important;">
              <div style="display: flex;align-items: flex-start;"><input type="checkbox" v-model="check"/></div>
              <div style="color: rgb(255, 255, 255);
    font-size: 10px;
    font-weight: 400;">I've read and understand the <a   class="cursor-pointer" @click="showPrivacy">{{ post_detail.company.name }}</a>'s Privacy Policy and <a  href="https://authorizelocal.com/portal-privacy-policy/" target="_blank">Authorize Local</a>'s Privacy Policy</div>
            </div>
          </div>
          <div :style="submit_style" class="al-button" @click.prevent="submitForm" >{{ post_detail.submit_data.text }}</div>
          <h3 class="submit-button-sub-text" :style="submit_subtext_style">{{post_detail.submit_data.subtext}}</h3>
        </form>
      </section>
      <section v-if="post_detail.custom_link.is_active" class="custom-link">
        <a :style="custom_link_style" :href="post_detail.custom_link.link" class="al-button" target="_blank">{{ post_detail.custom_link.button_title }}</a>
        <h3 :style="custom_link_style_title" v-if="post_detail.custom_link.title">{{post_detail.custom_link.title}}</h3>
      </section>
      <social-links :post_detail="post_detail" />
      <vue-bottom-sheet ref="sheet" class="form-bottom-sheet">
        <p v-html="post_detail.privacy"/>
      </vue-bottom-sheet>
    </main>
    <div class="already-played denied" v-else-if="!scratchStatus">
      <div class="short-message">
        <h2><i class="fas fa-times-circle"></i><br>This campaign has been stopped.</h2>
      </div>
    </div>
    <div class="already-played denied" v-else-if="!showScratch">
      <div class="short-message">
        <h2><i class="fas fa-times-circle"></i><br>You have already played. Please try again later.</h2>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import PhoneMaskInput from  'vue-phone-mask-input'

import SocialLinks from './SocialLinks'
import PlacesForm from '../components/places/PlacesForm'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
export default {
  props: {
    slug: String
  },
  data () {
    return {
      fingerprint: '',
      showScratch: true,
      scratchStatus: true,
      showScratchTime: 0,
      prizeItem: null,
      custom_list: [],
      scratchActive: false,
      fieldnames: [
        {
          name: 'Name',
          code: 'name',
          value: false
        },
        {
          name: 'Phone Number',
          code: 'phone',
          value: false
        },
        {
          name: 'Email',
          code: 'email',
          value: false
        },
        {
          name: 'Your Website',
          code: 'website',
          type: 'website',
          value: false
        },
        {
          name: 'Birthday',
          code: 'birthday',
          value: false
        },
        {
          name: 'Address',
          code: 'address',
          value: false
        }
      ],
      name: '',
      email: '',
      birthday: '',
      website: '',
      phone: '',
      address: null,
      address_text: '',
      state: '',
      city: '',
      zipcode: '',
      houseNo: '',
      location: '',
      showPrize: false,
      sheet: false,
      selectedPlace: null,
      check: false,
      setupTime: new Date().getTime().toString(),
      nowTime: new Date().getTime(),
      sessiomInterval: null,
      sessionid: (localStorage.getItem('sessionid') && localStorage.getItem('sessionid') !== 'undefined') ? localStorage.getItem('sessionid') : this.makeid(25)
    }
  },
  components: {
    PhoneMaskInput,
    SocialLinks,
    PlacesForm
  },
  async created () {
    if (this.slug) {
      const fp = await FingerprintJS.load()
      const result = await fp.get()
      this.fingerprint = result.visitorId
      this.getCard()
    }
  },
  destroyed () {
  },
  watch: {
    custom_list: {
      handler () {
        console.log('cl', this.custom_list)
      },
      deep: true
    }
  },
  computed: {
    customFieldList () {
      return JSON.parse(JSON.stringify(this.post_detail.customFieldList.map(field => {
        return {
          model: '',
          ...field
        }
      })))
    },
    submit_subtext_style () {
      if (this.campaign_theme.submit_subtext) {
        return `color: ${this.campaign_theme.submit_subtext.color}; font-size: ${this.campaign_theme.submit_subtext.size}px; font-weight: ${this.campaign_theme.submit_subtext.weight};`
      } else {
        return ''
      }
    },
    label_style () {
      if (this.campaign_theme.labels) {
        return `color: ${this.campaign_theme.labels.color}; font-size: ${this.campaign_theme.labels.size}px; font-weight: ${this.campaign_theme.labels.weight};`
      } else {
        return ''
      }
    },
    submit_style () {
      if (this.campaign_theme.submit) {
        return `background: ${this.campaign_theme.submit.background}; color: ${this.campaign_theme.submit.color}; font-size: ${this.campaign_theme.submit.size}px; font-weight: ${this.campaign_theme.submit.weight};`
      } else {
        return ''
      }
    },
    custom_link_style () {
      if (this.campaign_theme.custom_link) {
        return `background: ${this.campaign_theme.custom_link.background}; color: ${this.campaign_theme.custom_link.color}; font-size: ${this.campaign_theme.custom_link.size}px; font-weight: ${this.campaign_theme.custom_link.weight};`
      } else {
        return ''
      }
    },
    custom_link_style_title () {
      if (this.campaign_theme.custom_link) {
        return `color: ${this.campaign_theme.custom_link.title.color}; font-size: ${this.campaign_theme.custom_link.title.size}px; font-weight: ${this.campaign_theme.custom_link.title.weight};`
      } else {
        return ''
      }
    },
    timeDiff () {

      let msec = this.nowTime - this.setupTime
      const hh = Math.floor(msec / 1000 / 60 / 60)
      msec -= hh * 1000 * 60 * 60
      const mm = Math.floor(msec / 1000 / 60)
      msec -= mm * 1000 * 60
      const ss = Math.floor(msec / 1000)
      msec -= ss * 1000

      return `${hh}:${mm}:${ss}`

      //return msec
    },
    post_detail () {
      return this.$store.state.post_detail
    },
    main_style () {
      if (this.campaign_theme) {
        if (this.isObject(this.campaign_theme.main)) {
          return `background: url(${this.getImage(this.campaign_theme.main.url)})`
        } else if (this.campaign_theme.main !== '') {
          return `background: ${this.campaign_theme.main}`
        }
      }
      return ''
    },
    privacy_primary () {
      if (this.campaign_theme.privacy) {
        return `color: ${this.campaign_theme.privacy.primary_color}; font-size: ${this.campaign_theme.privacy.primary_size}px; font-weight: ${this.campaign_theme.privacy.primary_weight};`
      } else {
        return ''
      }
    },
    privacy_secondary () {
      if (this.campaign_theme.privacy) {
        return `color: ${this.campaign_theme.privacy.secondary_color}; font-size: ${this.campaign_theme.privacy.secondary_size}px; font-weight: ${this.campaign_theme.privacy.secondary_weight};`
      } else {
        return ''
      }
    },
    award_style () {
      if (this.campaign_theme.award) {
        return `color: ${this.campaign_theme.award.color}; font-size: ${this.campaign_theme.award.size}px; font-weight: ${this.campaign_theme.award.weight};`
      } else {
        return ''
      }
    },
    slogan_style () {
      if (this.campaign_theme.slogan) {
        return `color: ${this.campaign_theme.slogan.color}; font-size: ${this.campaign_theme.slogan.size}px; font-weight: ${this.campaign_theme.slogan.weight};`
      } else {
        return ''
      }
    },
    campaign_theme () {
      return this.$store.state.campaign_theme
    }
  },
  methods: {
    showPrivacy () {
      if (!this.sheet) {
        this.$refs.sheet.open()
      } else {
        this.$refs.sheet.close()
      }
      this.sheet = !this.sheet
    },
    resetAddress () {
      this.address_text = ''
      this.address = null
    },
    placesFound (value, location) {
      console.log('selected value', value)
      //this.business_address = value.description
      this.address = value
      this.address_text = `${this.address.no} ${this.address.street}, ${this.address.city}, ${this.address.state} ${this.address.zipcode}`
      this.location = location
    },
    onValidate (data) {
      console.log(data)
    },
    getImage (url) {
      return `https://restapi.authorizelocal.com/api/posts/photo/${url}`
    },
    isObject (a) {
      return (!!a) && (a.constructor === Object)
    },
    makeid (length) {
      let result = ''
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      const charactersLength = characters.length
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
      }
      return result
    },
    open_link (url) {
      window.open(url, '_blank')
    },
    submitForm () {
      this.$validator.validateAll('interaction').then(result => {
        let custom_valid = true
        if (this.custom_list.length > 0) {
          this.custom_list.map(custom => {
            if (custom.value) {
              if (custom.code === 'phone') {
                if (custom.model.length < 10) {
                  custom_valid = false
                }
              }
            }
          })
        }
        if (result && this.check && custom_valid) {
          const info_array = []
          if (this.name !== '') {
            info_array.push({name: this.name})
          }
          if (this.website !== '') {
            info_array.push({website: this.website})
          }
          if (this.email !== '') {
            info_array.push({email: this.email})
          }
          if (this.birthday !== '') {
            const save_date = moment(this.birthday, 'YYYY-MM-DD').toDate().toLocaleDateString('en-US')
            info_array.push({birthday: save_date})
          }
          if (this.phone !== '') {
            info_array.push({phone: this.phone})
          }
          if (this.address) {
            if (this.address !== '') {
              this.address.houseNo = this.houseNo
              info_array.push({
                address: {
                  address: this.address,
                  location: this.location
                }
              })
            }
          }

          if (this.custom_list.length > 0) {
            this.custom_list.map(custom => {
              const obj = {}
              obj[custom.name] = custom.model
              info_array.push(obj)
            })
          }

          const interaction = {
            post_id: this.post_detail._id,
            email: this.email,
            //prize: this.prizeItem,
            info: info_array
          }
          console.log(interaction)
          this.$vs.loading()
          this.$store.dispatch('setInteraction', interaction)
            .then(result => {
              if (result) {
                console.log(result)
                this.$vs.notify({
                  title: 'Success',
                  text: 'Information saved successfully',
                  color: 'success',
                  iconPack: 'feather',
                  icon: 'icon-check'
                })
                this.$router.push(`/scratch/code/${result.data.data.code}`)
                  .then(() => {
                    location.reload()
                  })
                this.$vs.loading.close()
              }
            })
            .catch(error => {
              this.$vs.notify({
                title: 'Info',
                text: error.message,
                color: 'warning',
                iconPack: 'feather',
                icon: 'icon-alert-circle'
              })
              this.$vs.loading.close()
            })
        } else if (!this.check) {
          this.$vs.notify({
            title: 'Error',
            text: 'Please agree to terms of service',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        } else {
          this.$vs.notify({
            title: 'Error',
            text: 'Please fill up the form',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        }
      })

    },
    setInteraction () {
      const info_array = []
      const interaction = {
        post_id: this.post_detail._id,
        email: null,
        //prize: this.prizeItem,
        info: info_array
      }
      console.log(interaction)
      this.$vs.loading()
      this.$store.dispatch('setInteraction', interaction)
        .then(result => {
          if (result) {
            console.log(result)
            this.$vs.notify({
              title: 'Success',
              text: 'Information saved successfully',
              color: 'success',
              iconPack: 'feather',
              icon: 'icon-check'
            })
            this.$router.push(`/scratch/game/${result.data.data.code}`)
              .then(() => {
                location.reload()
              })
            this.$vs.loading.close()
          }
        })
        .catch(error => {
          this.$vs.notify({
            title: 'Info',
            text: error.message,
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
          this.$vs.loading.close()
        })
    },
    checkSessionValid () {
      this.nowTime = new Date().getTime()
      let msec = this.nowTime - this.setupTime
      const hh = Math.floor(msec / 1000 / 60 / 60)
      msec -= hh * 1000 * 60 * 60
      const mm = Math.floor(msec / 1000 / 60)
      msec -= mm * 1000 * 60
      const ss = Math.floor(msec / 1000)
      msec -= ss * 1000

      console.log(`diff${msec}`, this.timeDiff)
      console.log('prize', this.prizeItem.name)
      if (hh === 0 && mm >= 30) {
        this.refreshSession()
      }

      if (!this.sessiomInterval) {
        this.sessiomInterval = setInterval(this.checkSessionValid, 1000 * 60)
      }

    },
    refreshSession () {
      console.log('refresing session')

      localStorage.removeItem('prize')
      localStorage.removeItem('session')
      localStorage.removeItem('setup')

      location.reload()
    },
    setupData () {
      this.prizeItem = this.post_detail.prizeList[Math.floor(Math.random() * this.post_detail.prizeList.length)]

      const { campaign_theme } = JSON.parse(JSON.stringify(this.post_detail))

      this.custom_list = this.customFieldList

      this.$store.commit('SET_CAMPAIGN_THEME', campaign_theme)
    },
    getdataImg (id) {
      return `https://restapi.authorizelocal.com/api/posts/photo/${id}`
    },
    getCard () {
      const payload = {
        slug: this.slug
      }
      this.$store.dispatch('getPostSlug', payload)
        .then(() => {
          if (this.post_detail.is_active) {
            const currentDate = moment()
            this.scratchActive = moment(this.post_detail.endDate).isAfter(currentDate)
            this.setupData()
            if (this.post_detail.scratchType === 'quickly') {
              this.$store.dispatch('checkFingerPrint', {code: this.slug, fingerprint: this.fingerprint})
                .then((checkFingerprint) => {
                  if (!checkFingerprint.status) {
                    this.showScratch = false
                  } else {
                    this.setInteraction()
                  }
                })
            }
          } else {
            this.scratchStatus = false
          }
        })
        .catch(error => {
          this.$vs.loading.close()
          console.log(error)
        })
    }
  }
}
</script>
<style lang="scss">

.already-played {
  width:100%;
  min-height: 100vh;
  display:flex;
  justify-content: center;
  align-items: center;
}
.denied{
  i {
    color:#c32429;
    font-size:42px;
  }
}
.short-message {
  h2{
    text-align: center;
  }
  display:flex;
  justify-content: center;
  align-items:center;
  font-size:32px;
  font-weight: 700;
  width:90%;
  padding:50px 20px;
  border-radius: 7px;
}
.form-bottom-sheet {
  z-index: 1 !important;

  .bottom-sheet__backdrop {
    /*margin: 70px 0 0 50px;*/
  }
  .bottom-sheet__content {
    /*margin: 0 0 0 50px;*/
    p {
      padding: 0 10px;
    }
  }
}
.form-agreement{
  display:flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  font-size:11px;
  margin:0px 0;
  div{
    padding:5px 0;
  }
  input {
    width:25px;
    height:25px;
    margin-bottom:0;
  }
  a {
    color:#f08028;
  }
  .al-button{
    font-size:26px;
  }
  .form-agreement-check{
    display:flex;
    justify-content: flex-start;
    align-items:center;
    font-size:9px;
    gap:5px;
  }
}
.form-area {
  input {
    background: white;
  }
  input[type="date"]{
    display:block!important;
    width:100% !important;
    padding:10px !important;
    -webkit-appearance: textfield;
    -moz-appearance: textfield;
    min-height: 48px;
  }
}
.scratch-blocker {
  position: absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  z-index:3;
}
.submit-description {
  text-align:center;
  font-size:14px;
  font-weight:bold;
  margin-bottom:20px;
}
.cardviewform main{
  width:100%;
  background-size:cover !important;
}
.cardviewform section{
  max-width:385px;
  display:block;
  margin:0 auto;
}
</style>
